import apiAction from 'common/redux/actions/apiAction';
import { DELETE_ADMIN_SHARED_FAVOURITE_FILTER } from './apiPathConstants';
import { logError } from 'TAP/utils/commonMethods';

const deleteSharedFavouriteSuccess = (data) => ({
  type: 'DELETE_ADMIN_SHARED_FAVOURITE_SUCCESS',
  payload: data,
});

const deleteSharedFavouriteError = () => ({
  type: 'DELETE_ADMIN_SHARED_FAVOURITE_ERROR',
});

export const AdminDeleteSharedFavouriteAction = (configParams) =>
  apiAction.deleteAPI({
    url: DELETE_ADMIN_SHARED_FAVOURITE_FILTER(),
    data: configParams,
    onSuccess: deleteSharedFavouriteSuccess,
    onFailure: (err) => {
      logError('Error occurred while unsharing favourite:', err);
      return deleteSharedFavouriteError();
    },
    label: 'DELETE_ADMIN_SHARED_FAVOURITE',
  });
